import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@/app/core/enums/PermissionEnum";

export const routePrivateAdmin: Array<RouteRecordRaw> = [
  {
    path: "admin",
    name: "Admin",
    meta: {
      requireAuth: true,
      permissions: [PermissionEnum.Admin],
    },
    props: true,
    component: () => import("@/app/private/pages/admin/Admin.vue"),
  },
  {
    path: "admin/accounts/:id",
    name: "AccountView",
    meta: {
      requireAuth: true,
      permissions: [PermissionEnum.Admin],
    },
    props: true,
    component: () => import("@/app/private/pages/admin/AccountView.vue"),
  },
  {
    path: "admin/accounts/new",
    name: "AccountCreate",
    meta: {
      requireAuth: true,
      permissions: [PermissionEnum.Admin],
    },
    props: true,
    component: () => import("@/app/private/pages/admin/AccountCreate.vue"),
  }
    
];
